import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import MFASetup from './MFASetup';
import MFAVerification from './MFAVerification';

const MFAPrompt = () => {
  const { 
    mfaRequired, 
    mfaSetupRequired, 
    pendingAuth,
    user,
    completeMFASetup, 
    completeMFAVerification, 
    cancelMFA 
  } = useContext(AuthContext);

  // Don't render if no MFA is required
  if (!mfaRequired && !mfaSetupRequired) {
    return null;
  }

  // Determine if MFA is required (not optional)
  // MFA is required for internal users, superusers, or when explicitly flagged
  const isMFARequired = user?.is_internal || user?.is_superuser || mfaSetupRequired || mfaRequired;

  // Render MFA setup modal
  if (mfaSetupRequired) {
    return (
      <MFASetup
        onSetupComplete={completeMFASetup}
        onCancel={isMFARequired ? null : cancelMFA} // No cancel if required
        userEmail={pendingAuth?.user?.email || user?.email}
        isRequired={isMFARequired}
      />
    );
  }

  // Render MFA verification modal
  if (mfaRequired) {
    return (
      <MFAVerification
        onVerificationComplete={completeMFAVerification}
        onCancel={isMFARequired ? null : cancelMFA} // No cancel if required
        userEmail={pendingAuth?.user?.email || user?.email}
        method={pendingAuth?.mfa_method || 'totp'}
      />
    );
  }

  return null;
};

export default MFAPrompt;
